import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ScribeMode } from '../../assessment-ai-scribe.model';

export type RecordState = 'idle' | 'requesting' | 'recording' | 'uploading' | 'recorded';

@Component({
  selector: 'csi-scribe-record-tab',
  templateUrl: './scribe-record-tab.component.html',
  styleUrls: ['./scribe-record-tab.component.scss']
  // NOTE: Do NOT use ChangeDetectionStrategy.OnPush here.
  // The parent (AssessmentAiScribeComponent) updates recordState inside
  // MediaRecorder callbacks and NgZone.run() calls. OnPush causes the UI to
  // lag one CD cycle behind those updates, requiring an extra user interaction
  // to flush the view — exactly the "needs two clicks" bug.
})
export class ScribeRecordTabComponent {
  @Input() recordState: RecordState = 'idle';
  @Input() formattedTime = '00:00';
  @Input() canSubmit = false;
  @Input() isSubmitting = false;
  @Input() activeMode: ScribeMode = 'extraction';

  @Input() liveTranscript = '';
  @Input() speechSupported = true;

  @Output() startRecording = new EventEmitter<void>();
  @Output() stopRecording = new EventEmitter<void>();
  @Output() resetRecord = new EventEmitter<void>();
  @Output() submitClicked = new EventEmitter<void>();
}
